export default function TravelAgentPopup(id = '') {
  this.currentEmail = '';
  this.id = id ? `#${id}` : '';

  this.init = () => {
    this.setSelectors();
    this.setHandlers();
    return this;
  };

  this.setSelectors = () => {
    this.selectorPopupOverlay = `${this.id}.js-ao-common-travel-agent-popup__overlay`;
    this.selectorClosePopup = `${this.id} .js-ao-common-travel-agent-popup__close, ${this.id} .js-ao-common-travel-agent-popup__cancel`;
    this.selectorAgentLogin = `${this.id} .js-ao-common-travel-agent-popup__cta`;
  };

  this.setHandlers = () => {
    $(document).on('click', this.selectorClosePopup, () => {
      this.close();
    });

    $(document).on('click', this.selectorAgentLogin, () => {
      this.triggerEvent('event:agentDetectionClick', 'Yes');
    });
  };

  this.setEmail = (email, currentId) => {
    const emailId = currentId ? `#${currentId}` : '';
    $(`${emailId} .ao-common-travel-agent-popup__email`).html(email);
  };

  this.triggerEvent = (event, data) => {
    $(document.body).trigger(event, data);
  };

  this.open = (email, currentId) => {
    const overlayId = currentId ? `#${currentId}` : '';
    this.setEmail(email, currentId);
    $(`${overlayId}.js-ao-common-travel-agent-popup__overlay`).removeClass('hid');
    this.triggerEvent('event:agentDetectionOpen');
  };

  this.close = () => {
    $(this.selectorPopupOverlay).addClass('hid');
    this.triggerEvent('event:agentDetectionClick', 'No');
  };

  this.checkCurrentEmail = (email) => {
    const result = this.currentEmail === email;
    this.currentEmail = email;
    return result;
  };
}
